export default {
  props: {
    /**
     * List of elements to render.
     */
    list: {
      type: Array,
      required: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/totalsTable/totalsTable.js